import axios from '@/plugins/axios'

const getUserHeader = (formData) => axios.get('users/header', formData)

export {
    getUserHeader,
}
